export default function DashboardPage() {

    return (
        <div className="flex flex-col items-center justify-center flex-grow">
            <h1>Dahsboard</h1>
        </div>
    ); 
}
